import type { InjectionKey, Ref } from 'vue'

/**
 * MYAC-1522 — where a letter-shaped chat puts its saved prompts and its help: the
 * host page's quiet top line, beside « Nouvelle session », as the dock has them
 * beside its own (Aymeric, 2026-10-06). The page provides the element; a letter
 * whose page offers none keeps them above the message box.
 */
export const LETTER_TOOLS_TARGET: InjectionKey<Ref<HTMLElement | null>> = Symbol('letterToolsTarget')
